import dayjs from 'dayjs';

type dateType = string | number | Date | dayjs.Dayjs | null | undefined;

export const dateToShortFormat = (date: dateType) => dayjs(date).format('DD.MM.YYYY');
export const dateToFullFormat = (date: dateType) => dayjs(date).format('DD.MM.YYYY HH:MM');
export const dateToShortHours = (date: dateType) => dayjs(date).format('HH:mm');
